import { render, staticRenderFns } from "./LiveEvent.vue?vue&type=template&id=59805bed&scoped=true&"
var script = {}
import style0 from "./LiveEvent.vue?vue&type=style&index=0&id=59805bed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59805bed",
  null
  
)

export default component.exports